<template>
  <div class="so-widget" v-bind="$attrs">
    <v-card
      :loading="loading"
      :class="{
        border: !noBorder && !filled,
        'bg-surface-dim': filled,
        'bg-transparent': plain,
        'pa-0': noPadding || plain,
        'h-100': fullHeight,
      }"
      :disabled="disabled"
      variant="flat"
      class="rounded"
      data-testid="so-widget"
    >
      <SoErrorBoundary>
        <v-card-title
          v-if="$slots.title || title"
          data-testid="so-widget-title"
          class="pt-4"
          :class="{ 'px-0': noPadding || plain }"
        >
          <slot name="title">
            <h6 class="font-weight-medium">{{ title }}</h6>
          </slot>
        </v-card-title>

        <v-card-subtitle
          v-if="$slots.subtitle"
          data-testid="so-widget-subtitle"
          :class="{ 'px-0': noPadding || plain }"
        >
          <slot name="subtitle"></slot>
        </v-card-subtitle>
        <v-card-text
          v-if="$slots.text || $slots.default"
          data-testid="so-widget-text"
          :class="{ 'pa-0': noPadding || plain, 'h-100': fillContainer }"
          class="so-widget-text"
        >
          <div
            ref="so-widget-content"
            :class="{ 'h-100 d-flex flex-column': fillContainer }"
          >
            <slot name="text"></slot>
            <slot name="default"></slot>
          </div>
        </v-card-text>
        <v-expand-transition
          v-if="$slots.expand"
          data-testid="so-widget-expand"
        >
          <slot name="expand"></slot>
        </v-expand-transition>
        <v-card-actions
          v-if="$slots.actions || showCopyButton"
          data-testid="so-widget-actions"
        >
          <slot name="actions"></slot>
          <template v-if="showCopyButton">
            <v-spacer />
            <SoCopyToClipboard :element-to-copy="SoWidget" />
          </template>
        </v-card-actions>
      </SoErrorBoundary>
    </v-card>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoErrorBoundary from "./SoErrorBoundary.vue"
  import SoCopyToClipboard, {
    CopyToClipboardElement,
  } from "./SoCopyToClipboard.vue"

  export default defineComponent({
    components: { SoErrorBoundary, SoCopyToClipboard },
    inheritAttrs: false,
    props: {
      title: {
        type: String,
        default: "",
      },
      loading: {
        type: Boolean,
        default: false,
      },
      noBorder: {
        type: Boolean,
        default: false,
      },
      noPadding: {
        type: Boolean,
        default: false,
      },
      filled: {
        type: Boolean,
        default: false,
      },
      fillContainer: {
        type: Boolean,
        default: false,
      },
      plain: {
        type: Boolean,
        default: false,
      },
      fullHeight: {
        type: Boolean,
        default: false,
      },
      showCopyButton: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        SoWidget: null as CopyToClipboardElement,
      }
    },
    mounted() {
      this.SoWidget = this.$refs["so-widget-content"] as HTMLElement
    },
  })
</script>
<style scoped>
  .so-widget {
    height: 100%;
  }
</style>
